






import Vue from 'vue';
import { Location } from 'vue-router';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'BuyCreditsCta',

  props: {
    ctaLabel: {
      type: String,
      default: 'Buy now'
    },
    color: {
      type: String,
      default: 'primary'
    },
    variant: {
      type: String,
      default: 'outlined'
    },
    small: {
      type: Boolean
    }
  },

  data() {
    return {};
  },

  computed: {
    ...mapGetters('client', ['isTelkomClient']),
    buttonProps() {
      return {
        [this.variant]: true,
        color: this.color,
        class: this.additionalClasses,
        small: this.small
      };
    },

    paygLocation(): Location {
      return {
        path: '/pay-as-you-go',
        query: { destination: this.$route.fullPath }
      };
    }
  },

  methods: {
    openTopUpPage() {
      console.log({ paygLocation: this.paygLocation });
      this.$router.push(this.paygLocation);
    },
    topUpManual() {
      this.$intercom.openChat(
        "Hi Mobiz team, I'd like to top-up my credits, please get in touch with me."
      );
    },
    topUpAccount() {
      if (this.isTelkomClient) {
        this.topUpManual();
      } else {
        this.openTopUpPage();
      }
    }
  }
});
